import { z } from "zod";
import { baseEntitySchema } from "./base";

export const rfmMetricsDataSchema = z.object({
  buyOrderCount: z.number().min(0),
  buyOrderTotalValue: z.number().min(0),
  lastBuyDate: z.date().nullable(),
  sellOrderCount: z.number().min(0),
  sellOrderTotalValue: z.number().min(0),
  lastSellDate: z.date().nullable(),
});

export type RFMMetrics = z.infer<typeof rfmMetricsDataSchema>;

export const customerMetricsDataSchema = z.object({
  airlineMilesMetrics: rfmMetricsDataSchema,
  hotelPointsMetrics: rfmMetricsDataSchema,
  creditCardPointsMetrics: rfmMetricsDataSchema,
});

export type CustomerMetricsData = z.infer<typeof customerMetricsDataSchema>;
export const customerMetricsSchema = baseEntitySchema.merge(
  customerMetricsDataSchema,
);
export type CustomerMetrics = z.infer<typeof customerMetricsSchema>;
